export const arrayToDict = (array: any, key: any) =>
  array.reduce((acc: any, obj: any) => ((acc[obj[key]] = obj), acc), {});

export const groupArray = (array: any, key: any) =>
  array?.reduce((acc: any, obj: any) => {
    acc[obj[key]] = acc[obj[key]] || []; // Ensure it's an array if undefined
    acc[obj[key]].push(obj);
    return acc;
  }, {});
